function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M137.155 321.928L-4.35848e-05 382.338L113.241 204.69L137.155 321.928Z",
  fill: "url(#paint0_linear_calc_left)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M45.2163 55.5216L146.322 43.3722L18.3137 2.64245L45.2163 55.5216Z",
  fill: "url(#paint1_linear_calc_left)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_calc_left",
  x1: -2.46531,
  y1: 414.001,
  x2: 97.2523,
  y2: 260.474,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#42FF99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8FFD2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_calc_left",
  x1: 163.976,
  y1: 53.1969,
  x2: 48.6628,
  y2: 54.1464,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#42FF99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8FFD2"
})));

var SvgCalculatorLeftTriangles = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 421,
    viewBox: "0 0 173 421",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalculatorLeftTriangles, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calculator-left-triangles.fa512cb6.svg";
export { ForwardRef as ReactComponent };